import React from "react";
import "./GPTeam.css";

const teamMembers = [
 
  
];

// === नवीन कर्मचारी Data ===
const employees = [
    { name: "माधुरी प्रदीप चोपडे", designation: "संगणक परिचालक", phone: "+91-9226937968", imageUrl: "/images/operator.jpeg" },

  { name: "योगिता गजानन खवशी", designation: "अंगणवाडी सेविका", phone: "+91- 9022016201", imageUrl: "/images/yogita.jpeg" },
  { name: "आशा सतीश धारपुरे ", designation: "CRP", phone: "+91-8805907483", imageUrl: "/images/asha.jpeg" },
  { name: "ललित चेर", designation: " ग्राम पंचायत शिपाई", phone: "+91-7020611488", imageUrl: "/images/lalit.jpeg" },
  { name: "श्री गेंदराज टोपले", designation: "ग्राम पंचायत  पाणी पुरवठा सहाय्यक दाभा", phone: "+91-9823458825", imageUrl: "/images/gendalal.jpeg" },
  { name: "श्री नरेश अजाब चोपडे", designation: " पाणी पुरवठा सहाय्यक धावडी", phone: "+91-9158057150", imageUrl: "/images/naresh.jpeg" },
    { name: "श्री सुरेश दुपारे", designation: "ग्राम पंचायत पाणी पुरवठा कर्मचारी भालेवाडी", phone: "+91-7498048664", imageUrl: "/images/suresh.jpeg" }


];

const GPTeam = () => {
  return (
    <div className="gp-container">

      {/* HEADER */}
      <div className="gp-header">
        <img src="/images/sj1.jpg" alt="Emblem" className="gp-logo" />
        <h1 className="gp-title">ग्रामपंचायत कार्यकारी समिती</h1>
        <p className="gp-subtitle">The Governing Body — Committed to Community Service</p>
      </div>

      {/* TEAM MEMBERS GRID */}
      <div className="gp-grid">
        {teamMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img src={member.imageUrl} alt={member.name} className="gp-photo" />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
            <p className="gp-phone">📞 {member.phone}</p>
          </div>
        ))}
      </div>

      {/* ---- कर्मचार्‍यांचा विभाग ---- */}
      <h1 className="gp-title" style={{ marginTop: "40px" }}>
        🌟 ग्रामपंचायत कर्मचारी 🌟
      </h1>

      <div className="gp-grid">
        {employees.map((emp, index) => (
          <div key={index} className="gp-card">
            <img src={emp.imageUrl} alt={emp.name} className="gp-photo" />
            <h2 className="gp-name">{emp.name}</h2>
            <p className="gp-designation">{emp.designation}</p>
            <p className="gp-phone">📞 {emp.phone}</p>
          </div>
        ))}
      </div>

      {/* FOOTER */}
      <div className="gp-footer">© 2025 Gram Panchayat — All Rights Reserved.</div>
    </div>
  );
};

export default GPTeam;
